import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { homeRoute } from "../../routes/routesPath";
import Header from "../../Component/Header/Header";
import Footer, { SubFooter } from "../../Component/Footer/Footer";

const Pagenotfound = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="mainWrapper">
        <Header />
        <main className="mainBody max-w-unset">
          <section className="">
            <Row className="d-flex bg-white align-items-center">
              <Col md={6} className="text-center">
                <img src="/images/noPage.png" alt="" className="img-fluid" />
              </Col>
              <Col md={6} className="align-self-center text-center my-4">
                <h1 className="m-0">OOPS!</h1>
                <h3 className="fw-bold m-0">PAGE NOT FOUND</h3>
                <p className="extraLarge fw-sbold my-4 mx-3">
                  You must have picked the wrong door because I haven't been able to lay my eye on
                  the page you've been searching for.
                </p>
                <Button className="text-uppercase" onClick={() => navigate(homeRoute)}>
                  Back to home
                </Button>
              </Col>
            </Row>
          </section>
        </main>
        <SubFooter />
        <Footer />
      </div>
    </>
  );
};

export default Pagenotfound;
